import { lazy } from 'react';
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

export const navigateTo = (to: string) => {
  history.push(to);
};

export function mapRoutesComponents(routes) {
  return routes?.map((route: any) => {
    if (route.subRoutes?.length) {
      route.subRoutes = mapRoutesComponents(route.subRoutes);
    }

    return {
      ...route,
      component: route.loader && lazy(route.loader),
    };
  });
}
